<template>
  <section class="home">
    <za-banner></za-banner>
    <article class="article">
      <h1 class="article-title">行业数据报告——专注互联网数据研究发展</h1>
      <section class="article-inner">
        <template v-for="(item, index) in reportsList">
          <div class="article-item" :key="index">
            <router-link to="/login">
              <div class="article-item-cover">{{item.title}}</div>
              <h2 class="article-item-title">{{item.title}}</h2>
              <p class="article-item-desc">{{item.desc}}</p>
            </router-link>
          </div>
        </template>
      </section>
      <div class="more-link"><router-link to="/reports">更多报告&nbsp;<span>&gt;</span></router-link></div>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      reportsList: [{
        title: '中国网络文学版权保护研究报告',
        desc: '基于中国网络文学正版化进程迈入发展新阶段的时代背景，在梳理中国网络文学行业发展脉络的同时，以行业整体视角回顾......'
      }, {
        title: '移动互联网虚拟化技术发展报告',
        desc: '基于移动互联网虚拟化技术与PC端联合对比，跟踪虚拟化技术的发展趋势与历史沿革，从横纵向的角度，梳理了虚拟化技术......'
      }, {
        title: '中国互动娱乐季度数据发布研究报告',
        desc: '基于多年游戏行业研究、数据积累以及市面产品监测成果，通过对娱乐应用类型、题材、IP等各个因素的分析，从技术、市.......'
      }, {
        title: '中国移动营销行业洞察报告',
        desc: '按照营销产业链的维度划分，参与营销的企业主要有广告主、营销供应商、媒体三大类型。广告主作为产业链的开端和需求......'
      }]
    }
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 130px; 
}
.article-title {
  font-size: 36px;
  text-align: center;
}
.article-inner {
  padding: 65px 88px;
  font-size: 18px;
  overflow: auto;
}
.article-item {
  width: 202px;
  float: left;
  margin-right: 72px;
}
.article-item:nth-child(4n) {
  margin-right: 0;
}
.article-item-cover {
  width: 202px;
  height: 160px;
  padding: 12px;
  color: rgba(255, 255, 255, .7);
  background-image: url('../assets/cardBg.png');
}
.article-item-title {
  width: 180px;
  margin: 20px auto;
  text-align: center;
  color: #000;
}
.article-item-desc {
  font-size: 14px;
  line-height: 30px;
  color: #333;
}
.more-link {
  text-align: center;
}
.more-link a {
  font-size: 18px;
  height: 27px;
  line-height: 27px;
  display: inline-block;
  color: #016091;
  padding-bottom: 1px;
}
.more-link a:hover {
  border-bottom: 1px solid #016091;
}
.more-link a span {
  font-weight: 700;
}
</style>